import { uploadComplete } from '../actions/upload'
import { getType } from 'typesafe-actions'

export interface TagManagerState {
  userPaperCount: number
  user_id?: string
  user?: object
  loggedIn?: string
  accountMemberType?: string
  wptUserID?: string
  archieLeagueAdVersion?: 'string'
}

const initialState: TagManagerState = {
  userPaperCount: 0,
}

export const tagmanager = (state: TagManagerState = initialState, action: any) => {
  switch (action.type) {
    case getType(uploadComplete): {
      return Object.assign({}, state, {
        userPaperCount: state.userPaperCount + 1,
      })
    }
    default:
      return state
  }
}
export default tagmanager
